import IndexedDb, {TableData} from "./IndexedDb";

const DATABASE_NAME = "browser_player"
const TABLE_DATA = [{tableName: "playlist_shortlist", keyPath: null, autoIncrement: false} as TableData,{tableName: "keyvalue", keyPath: null, autoIncrement: false} as TableData ]

export class IndexedDbFactory {

    private static instance: IndexedDb;

    private constructor() {
        // Private constructor to prevent direct instantiation
    }

    public static getInstance(): IndexedDb {
        if (!IndexedDbFactory.instance) {
            // IndexedDb handles async DB connection internally via dbPromise,
            // so we can create the instance synchronously
            IndexedDbFactory.instance = new IndexedDb(DATABASE_NAME, TABLE_DATA);
        }
        return IndexedDbFactory.instance;
    }
}